// src/TermsAndConditions.js

import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="terms-and-conditions">
      <h1>Terms and Conditions</h1>
      <h2>Limitations of Liability</h2>
      <p>
        We will not be liable for any damages arising from the use of this website. This includes, but is not limited to, direct, indirect, incidental, punitive, and consequential damages.
      </p>
      <h2>Changes to These Terms</h2>
      <p>
        We may update these terms and conditions at any time. By continuing to use the website after changes are made, you agree to the updated terms.
      </p>
    </div>
  );
};

export default TermsAndConditions;
